import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import App from "./App";
import "@fontsource/inter";
import { DrawerProvider } from "./Context/DrawerContext";
// import { UserProvider } from "./Context/UserContext";
import { ColorProvider } from "./Context/ColorContext";
import theme from "./styles/Typography";
import "./styles/Colors.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";

// ✅ AG Grid: Register both Community + Enterprise modules
import { ModuleRegistry } from "ag-grid-community";
import { ClientSideRowModelModule } from "ag-grid-community";
import { MenuModule, ExcelExportModule } from "ag-grid-enterprise"; 
import { SbTypeProvider } from "./Context/sbTypeContext";
import { InvoiceProvider } from "./Context/InvoiceContext";
import { CustomerProvider } from "./Context/CustomerContext";
import { ProductProvider } from "./Context/ProductContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GlobalFilterProvider } from "@/Context/GlobalFilterContext";

ModuleRegistry.registerModules([
  ClientSideRowModelModule, // ✅ This was missing
  MenuModule,
  ExcelExportModule,
]);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>

  <Provider store={store}>
    <BrowserRouter basename={import.meta.env.VITE_BASE_BASENAME}>
      <SbTypeProvider>
        <QueryClientProvider client={queryClient}>
          {/* <UserProvider> */}
          <InvoiceProvider>
            <CustomerProvider>
              <GlobalFilterProvider>
                <ProductProvider>
                  <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <DrawerProvider>
                      <ColorProvider>
                        <App />
                      </ColorProvider>
                    </DrawerProvider>
                  </ThemeProvider>
                </ProductProvider>
              </GlobalFilterProvider>
            </CustomerProvider>
          </InvoiceProvider>
          {/* </UserProvider> */}
        </QueryClientProvider>
      </SbTypeProvider>
    </BrowserRouter>
  </Provider>

  // </React.StrictMode>
);
